import { useState } from "react";
import { UI_BASE } from "../config/bank";
import { useAuth } from "../context/useAuth"

export default function CustomerModal({ isOpen, onClose, onSuccess }) {
  const [form, setForm] = useState({
    fullname: "",
    email: "",
    phone: "",
    address: "",
    date_of_birth: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const {data, setData} = useState(null)
  
 
  //if (!isOpen) return null;

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const validate = () => {
    if (!form.fullname) return "Full name is required.";
    if (!form.email) return "Email is required.";
    if (!form.phone) return "Phone is required.";
    if (!form.address) return "Address is required.";
    if (!form.date_of_birth) return "Date of birth is required.";
    return null;
  };

  async function handleSubmit(e) {
    e.preventDefault();
    const validationError = validate();
    if (validationError) {
      setError(validationError);
      return;
    }

    setError("");
    setLoading(true);


    try {
      //const resp = await fetch(`${UI_BASE}/bnk/customer`, {
      const resp = await fetch('/bnk/customer', {  
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          //"X-Requested-With": "XMLHttpRequest",
      },
     // body: JSON.stringify({ fullname, email, phone, address, date_of_birth }),
     body: JSON.stringify(form),
    });

    if (!resp.ok) {
      setError("Submission failed. Please try again.");
      return;
    }
    const data = await resp.json();

    onSuccess?.(data);
    onClose?.();

    } catch (err) {
      console.error("FETCH ERROR:", err);
      setError("Unable to connect. Please try again.");
    } finally {
      setLoading(false);
    }
    
  }

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-[rgba(15,20,35,0.55)] p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="customer-modal-title"
    >
      <div className="w-full max-w-[420px] rounded-xl border border-black/10 bg-white p-8">

        {/* Header */}
        <div className="mb-7 flex items-center gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[#EBF4FF] text-[#185FA5]">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
              aria-hidden="true">
              <circle cx="12" cy="8" r="4"/>
              <path d="M4 21c0-4 3.6-7 8-7s8 3 8 7"/>
            </svg>
          </div>
          <div>
            <p id="customer-modal-title" className="m-0 text-[15px] font-medium text-gray-900">Create customer</p>
            <p className="m-0 text-xs text-gray-400">Banking assistant</p>
          </div>
          <button
            onClick={onClose}
            aria-label="Close"
            className="ml-auto p-1 text-base leading-none text-gray-400 hover:text-gray-600"
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} noValidate>

          {/* Full name */}
          <div className="mb-4">
            <label htmlFor="fullname" className="mb-1.5 block text-xs text-gray-500">Full name</label>
            <div className="relative">
              <svg className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-300"
                width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
              </svg>
              <input
                id="fullname"
                name="fullname"
                type="text"
                value={form.fullname}
                onChange={handleChange}
                placeholder="Enter full name"
                autoComplete="name"
                className="h-[38px] w-full rounded-lg border border-black/20 bg-white pl-[34px] pr-3 text-sm text-gray-900 outline-none focus:border-[#185FA5] focus:ring-1 focus:ring-[#185FA5]/30"
              />
            </div>
          </div>

          {/* Email */}
          <div className="mb-4">
            <label htmlFor="email" className="mb-1.5 block text-xs text-gray-500">Email</label>
            <div className="relative">
              <svg className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-300"
                width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="3" y="5" width="18" height="14" rx="2"/>
                <path d="m3 7 9 6 9-6"/>
              </svg>
              <input
                id="email"
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Enter email address"
                autoComplete="email"
                className="h-[38px] w-full rounded-lg border border-black/20 bg-white pl-[34px] pr-3 text-sm text-gray-900 outline-none focus:border-[#185FA5] focus:ring-1 focus:ring-[#185FA5]/30"
              />
            </div>
          </div>

          {/* Phone */}
          <div className="mb-4">
            <label htmlFor="phone" className="mb-1.5 block text-xs text-gray-500">Phone</label>
            <div className="relative">
              <svg className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-300"
                width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/>
              </svg>
              <input
                id="phone"
                name="phone"
                type="tel"
                value={form.phone}
                onChange={handleChange}
                placeholder="Enter phone number"
                autoComplete="tel"
                className="h-[38px] w-full rounded-lg border border-black/20 bg-white pl-[34px] pr-3 text-sm text-gray-900 outline-none focus:border-[#185FA5] focus:ring-1 focus:ring-[#185FA5]/30"
              />
            </div>
          </div>

          {/* Address */}
          <div className="mb-4">
            <label htmlFor="address" className="mb-1.5 block text-xs text-gray-500">Address</label>
            <div className="relative">
              <svg className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-300"
                width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <circle cx="12" cy="10" r="3"/>
                <path d="M12 21s7-7.5 7-12a7 7 0 1 0-14 0c0 4.5 7 12 7 12z"/>
              </svg>
              <input
                id="address"
                name="address"
                type="text"
                value={form.address}
                onChange={handleChange}
                placeholder="Enter address"
                autoComplete="street-address"
                className="h-[38px] w-full rounded-lg border border-black/20 bg-white pl-[34px] pr-3 text-sm text-gray-900 outline-none focus:border-[#185FA5] focus:ring-1 focus:ring-[#185FA5]/30"
              />
            </div>
          </div>

          {/* Date of birth */}
          <div className="mb-6">
            <label htmlFor="date_of_birth" className="mb-1.5 block text-xs text-gray-500">Date of birth</label>
            <div className="relative">
              <svg className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-300"
                width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="3" y="5" width="18" height="16" rx="2"/>
                <path d="M16 3v4M8 3v4M3 9h18"/>
              </svg>
              <input
                id="date_of_birth"
                name="date_of_birth"
                type="date"
                value={form.date_of_birth}
                onChange={handleChange}
                className="h-[38px] w-full rounded-lg border border-black/20 bg-white pl-[34px] pr-3 text-sm text-gray-900 outline-none focus:border-[#185FA5] focus:ring-1 focus:ring-[#185FA5]/30"
              />
            </div>
          </div>

          {/* Error */}
          {error && (
            <div role="alert" className="mb-4 rounded-lg border border-red-300 bg-red-50 px-3 py-2.5 text-[13px] text-red-800">
              <span className="mr-1.5">⚠</span>{error}
            </div>
          )}

          {/* Actions */}
          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="h-10 flex-1 rounded-lg border border-black/10 bg-gray-100 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="h-10 flex-1 rounded-lg border border-blue-300 bg-[#EBF4FF] text-sm font-medium text-[#185FA5] transition-colors hover:bg-blue-100 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {loading ? "Submitting…" : "Submit"}
            </button>
          </div>

        </form>

      </div>
    </div>
  );
}
